module.exports = __webpack_public_path__ + "static/empathy-1dac22825b2fc056d14db72f6cd79656.png";